import React from "react";
import {connect} from "react-redux";
import classNames from "classnames";
import {getTranslate, TranslateFunction} from "react-localize-redux";
import {formatString} from "@data-force/app";
import {MaskMessage} from "../../enums/enums";
import "./MaskMessageHolder.scss";
import StoreState from "../../interfaces/store/storeState";

interface OwnProps {
    ariaRole: string
    translationPath: string
    rejectedTaskCount: number
}

interface StateProps {
    translate: TranslateFunction
}

type Props = StateProps & OwnProps;

const MaskMessageHolder: React.FC<Props> = (props: Props): React.ReactElement => {
    const {
        ariaRole, translationPath, translate, rejectedTaskCount,
    }: Props = props;

    const intakeCompletedMessage: string = translate(`${translationPath}.intakeCompleted.text`) as string;
    const howeverMessage: string = translate(`${translationPath}.however.text`) as string;
    const allMessage: string = translate(`${translationPath}.all.text`) as string;

    const contactSupportMessage: string = translate(`${translationPath}.contactSupport.text`) as string;

    let endOfTheSentence: string;
    let maskMessage: React.ReactNode;

    switch (ariaRole) {
        case MaskMessage.TERMINAL_REJECTION:
            endOfTheSentence = translate(`${translationPath}.intakeAllTasksRejectedSentenceEnd.text`) as string;
            maskMessage = (
                <span>
                    {intakeCompletedMessage}
                    {howeverMessage}
                    <b>
                        {allMessage}
                        {endOfTheSentence}
                    </b>

                    {contactSupportMessage}
                </span>
            );
            break;
        case MaskMessage.PARTIAL_REJECTION:
            endOfTheSentence = formatString(
                translate(`${translationPath}.rejectedTasks.text`) as string,
                rejectedTaskCount.toString(),
            );
            maskMessage = (
                <span>
                    {intakeCompletedMessage}
                    {endOfTheSentence}
                    {contactSupportMessage}
                </span>
            );
            break;
        default:
            maskMessage = (
                <span>{intakeCompletedMessage}</span>
            );
            break;
    }

    const maskMessageIconClass: string = classNames({
        "df-mask-message-icon": true,
        "df-icon-success": ariaRole === MaskMessage.INTAKE_COMPLETED,
        "df-icon-warning": ariaRole === MaskMessage.PARTIAL_REJECTION,
        "df-icon-error": ariaRole === MaskMessage.TERMINAL_REJECTION,
    });

    return (
        <div className="df-mask-message-container">
            <div className={maskMessageIconClass}/>
            {maskMessage}
        </div>
    );
};

function mapStateToProps({
    localize,
}: StoreState): StateProps {
    const translate: TranslateFunction = getTranslate(localize);
    return {
        translate,
    };
}

export default connect(mapStateToProps)(MaskMessageHolder);
